var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.825 19.552a.794.794 0 001.588 0V15.55h-1.588zm3.2-7.449l-1.433-.733-.725-2.735a.773.773 0 00-.384-.442l-1.137-.572a1.344 1.344 0 00-1.756.525l-2.096 3.28a1.389 1.389 0 00.812 2.07l4.056 1.423-2.17-2.34 1.887-3.135.603 2.366a.7.7 0 00.345.398l1.542.785a.5.5 0 00.456-.89zm-2.29-7.4a1.43 1.43 0 11-1.43 1.43 1.43 1.43 0 011.43-1.43zM22.5 17.359a3.49 3.49 0 00-1.357.273l-1.383-2.3v-2.473a.5.5 0 00-.5-.5h-2a.5.5 0 000 1h1.54v1.557l-5.517.891-.81-1.618 1.195-.103a.364.364 0 00-.032-.727h-3.14a.5.5 0 000 1l.905-.078.41.818-1.225 2.45a3.462 3.462 0 00-1.086-.19 3.5 3.5 0 103.45 4.001h1.143a1.489 1.489 0 002.888-.69l2.655-3.605.659 1.097a3.482 3.482 0 102.205-.803zm-13 6a2.5 2.5 0 010-5 2.468 2.468 0 01.635.092l-1.093 2.185a.5.5 0 00.447.724h2.46A2.504 2.504 0 019.5 23.358zm.798-2.999l.732-1.464a2.493 2.493 0 01.92 1.464zm3.794 0H12.95a3.488 3.488 0 00-1.463-2.378l.883-1.765 1.896 3.792a1.496 1.496 0 00-.174.35zm1.408.999a.5.5 0 11.5-.5.5.5 0 01-.5.5zm.949-1.653a1.434 1.434 0 00-1.358-.283l-1.34-2.68 5.187-.836.139.23zm6.051 3.653a2.492 2.492 0 01-1.686-4.333l1.257 2.09a.5.5 0 10.858-.515l-1.257-2.09a2.47 2.47 0 01.828-.152 2.5 2.5 0 010 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.793 7.207l1.414-1.414 19 19-1.414 1.414z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--biking-prohibited-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'BikingProhibitedCircleIcon';
export default Icon;